import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { StatisticheComponent } from './statistiche.component';
import { DropdownModule } from 'primeng/dropdown';

@NgModule({
  declarations: [
    StatisticheComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    DropdownModule
  ],
  exports: [
    StatisticheComponent
  ]
})
export class StatisticheModule { }
